var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-element-permissions",
    },
    [
      _vm.message != false
        ? _c(
            "studip-message-box",
            {
              attrs: {
                type: _vm.message.type ? _vm.message.type : "info",
                details: _vm.message.details ? _vm.message.details : [],
                hideClose: false,
              },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$gettext(_vm.message.text)) + "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "default",
        },
        [
          _c("caption", [_c("translate", [_vm._v("Personen")])], 1),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", [_c("translate", [_vm._v("Name")])], 1),
              _vm._v(" "),
              _c("th", [_c("translate", [_vm._v("Leserechte")])], 1),
              _vm._v(" "),
              _c(
                "th",
                [_c("translate", [_vm._v("Lese- und Schreibrechte")])],
                1
              ),
              _vm._v(" "),
              _c("th", [_c("translate", [_vm._v("Ablaufdatum")])], 1),
              _vm._v(" "),
              _c(
                "th",
                {
                  staticClass: "actions",
                },
                [_c("translate", [_vm._v("Aktion")])],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm.listEmpty
                ? _c(
                    "tr",
                    {
                      staticClass: "empty",
                    },
                    [
                      _c(
                        "td",
                        {
                          attrs: {
                            colspan: "5",
                          },
                        },
                        [
                          _c("translate", [
                            _vm._v("Es wurden noch keine Freigaben erteilt"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.userPermsList, function (user_perm, index) {
                return _c(
                  "tr",
                  {
                    key: index,
                  },
                  [
                    _c("td", [
                      _c("label", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(user_perm["formatted-name"]) +
                            "\n                        "
                        ),
                        _c("i", [_vm._v(_vm._s(user_perm.username))]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "perm",
                      },
                      [
                        _c("input", {
                          staticClass: "right",
                          attrs: {
                            title: _vm.$gettextInterpolate(
                              _vm.$gettext("Leserechte für %{ userName }"),
                              {
                                userName: user_perm.username,
                              },
                              true
                            ),
                            type: "radio",
                            name: "".concat(user_perm.id, "_right"),
                            value: "read",
                          },
                          domProps: {
                            checked:
                              _vm.userPermsList[index]["read"] &&
                              !_vm.userPermsList[index]["write"],
                          },
                          on: {
                            change: function change($event) {
                              return _vm.updateReadWritePerm(
                                index,
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "perm",
                      },
                      [
                        _c("input", {
                          staticClass: "right",
                          attrs: {
                            title: _vm.$gettextInterpolate(
                              _vm.$gettext(
                                "Lese- und Schreibrechte für %{ userName }"
                              ),
                              {
                                userName: user_perm.username,
                              },
                              true
                            ),
                            type: "radio",
                            name: "".concat(user_perm.id, "_right"),
                            value: "write",
                          },
                          domProps: {
                            checked:
                              _vm.userPermsList[index]["read"] &&
                              _vm.userPermsList[index]["write"],
                          },
                          on: {
                            change: function change($event) {
                              return _vm.updateReadWritePerm(
                                index,
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userPermsList[index]["expiry"],
                            expression: "userPermsList[index]['expiry']",
                          },
                        ],
                        staticStyle: {
                          cursor: "pointer !important",
                        },
                        attrs: {
                          title: _vm.getExpiryTitle(
                            user_perm.username,
                            _vm.userPermsList[index]["expiry"]
                          ),
                          type: "date",
                          min: _vm.minDate,
                          id: "".concat(user_perm.id, "_expiry"),
                        },
                        domProps: {
                          value: _vm.userPermsList[index]["expiry"],
                        },
                        on: {
                          change: _vm.refreshReadWriteApproval,
                          input: function input($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.userPermsList[index],
                              "expiry",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "actions",
                      },
                      [
                        _c("button", {
                          staticClass: "cw-permission-delete",
                          attrs: {
                            title: _vm.$gettextInterpolate(
                              _vm.$gettext(
                                "Entfernen der Rechte von %{ userName }"
                              ),
                              {
                                userName: user_perm.username,
                              },
                              true
                            ),
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              return _vm.confirmDeleteUserPerm(index)
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("tfoot", [
            _c("tr", [
              _c(
                "td",
                {
                  attrs: {
                    colspan: "5",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "multibuttons",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "button add cw-add-persons",
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              _vm.showAddMultiPersonDialog = true
                            },
                          },
                        },
                        [_c("translate", [_vm._v("Personen hinzufügen")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          class: {
                            disabled: _vm.listEmpty,
                          },
                          attrs: {
                            disabled: _vm.listEmpty,
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              return _vm.setAllPerms("read")
                            },
                          },
                        },
                        [_c("translate", [_vm._v("Allen Leserechte geben")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          class: {
                            disabled: _vm.listEmpty,
                          },
                          attrs: {
                            disabled: _vm.listEmpty,
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              return _vm.setAllPerms("write")
                            },
                          },
                        },
                        [
                          _c("translate", [
                            _vm._v("Allen Lese- und Schreibrechte geben"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.showAddMultiPersonDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Personen hinzufügen"),
              confirmText: _vm.$gettext("Speichern"),
              confirmClass: "accept",
              closeText: _vm.$gettext("Schließen"),
              closeClass: "cancel",
              height: "500",
              width: "750",
            },
            on: {
              close: _vm.clearSelectedUsers,
              confirm: _vm.getSelectedUsers,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c("studip-multi-person-search", {
                        attrs: {
                          name: "content-persons",
                        },
                        model: {
                          value: _vm.selectedUsers,
                          callback: function callback($$v) {
                            _vm.selectedUsers = $$v
                          },
                          expression: "selectedUsers",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4082570935
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Personen löschen"),
              question: _vm.$gettext(
                "Möchten Sie diese Person wirklich löschen?"
              ),
              height: "180",
            },
            on: {
              confirm: _vm.performDeleteUserPerm,
              close: _vm.clearDeleteUserPerm,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [
      _c("col", {
        staticStyle: {
          width: "35%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "15%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "25%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "15%",
        },
      }),
      _vm._v(" "),
      _c("col", {
        staticStyle: {
          width: "10%",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }